export const API_ENDPOINT_REPORTS_LIST_BY_WORKSPACE = `${process.env.REACT_APP_API_URL}/meta/reports/list`;
export const API_ENDPOINT_REPORTS_REMOVE_FROM_WORKSPACE = `${process.env.REACT_APP_API_URL}/meta/reports/delete`;
export const API_ENDPOINT_REPORTS_REMOVE_FROM_WORKSPACE_NEW = `${process.env.REACT_APP_API_URL}/meta/reports/delete/new`;
